export enum AppRoute {
  Homepage = '/',
  Login = '/login',

  TutorKanbanOnboarding = '/tutor-kanban/onboarding',
  TutorKanbanActive = '/tutor-kanban/active',
  TutorKanbanProbation = '/tutor-kanban/probation',
  TutorKanbanInfo = '/tutor-kanban/[id]/info',
  TutorKanbanComments = '/tutor-kanban/[id]/comments',
  TutorKanbanLog = '/tutor-kanban/[id]/log',

  TasksKanbanSupport = '/tasks-kanban/support',
  TasksKanbanSuccess = '/tasks-kanban/success',
  TasksKanbanBilling = '/tasks-kanban/billing',
  TasksKanbanCreation = '/tasks-kanban/creation',
  TasksKanbanLog = '/tasks-kanban/[id]/log',
  TasksKanbanInfo = '/tasks-kanban/[id]/info',

  TutorsLegal = '/tutors/[id]/legal',
  TutorsPaymentPolicy = '/tutors/[id]/payment-policy',
  BillingTutorInfo = '/billing/tutor-billing-info',

  Customers = '/customers',
  CustomersShow = '/customers/[id]',
  CustomersDetails = '/customers/[id]/details',
  CustomersStatusesAndSources = '/customers/[id]/statuses-and-sources',
  CustomersComments = '/customers/[id]/comments',
  CustomersSubscriptions = '/customers/[id]/subscriptions',
  CustomersOrders = '/customers/[id]/orders',
  CustomersCredits = '/customers/[id]/credits',
  CustomersChangelog = '/customers/[id]/changelog',
  CustomersTaskComments = '/customers/[id]/task-comments',
  DisciplinesGeneralInfo = '/disciplines/[id]',
  DisciplinesBalances = '/disciplines/[id]/balances',
  DisciplinesTasks = '/disciplines/[id]/tasks',
  DisciplinesFiles = '/disciplines/[id]/files',
  DisciplinesReport = '/disciplines/[id]/report',
  DisciplinesStageLogs = '/disciplines/[id]/stage-logs',
  DisciplinesComments = '/disciplines/[id]/comments',
  DisciplinesChangelog = '/disciplines/[id]/changelog',
  DisciplinesSurveys = '/disciplines/[id]/surveys',
  DisciplinesActivation = '/disciplines/[id]/activation',
  DisciplinesProgressReports = '/disciplines/[id]/progress-reports',
  DisciplinesOrdersCreate = '/disciplines/[id]/orders/create',
  DisciplinesTaskComments = '/disciplines/[id]/task-comments',
  KidsShow = '/kids/[id]',
  KidsChangelog = '/kids/[id]/changelog',
  DisciplinesLessons = '/disciplines/[id]/lessons',
  LessonsCreate = '/disciplines/[id]/lessons/create',
  LessonsEdit = '/disciplines/[id]/lessons/[lessonId]',
  LessonsConnectionLog = '/disciplines/[id]/lessons/[lessonId]/connection-log',
  BookingsChangelog = '/bookings/[id]/changelog',

  TutorKanbanTimeOffs = '/tutor-kanban/[id]/time-offs',
  DemosExtraRates = '/demos/extra-rates',
  DemosSlotsTracker = '/demos/slots-tracker',
  DemosTutorSlotLog = '/demos/tutor-slot-log',
  DemosSlotsManagement = '/demos/slots-management',
  DemosSlotsManagementSalesQueue = '/demos/slots-management/sales-queue',

  ApiTokens = '/api-tokens',
  Promocodes = '/promocodes',
  Orders = '/orders',
  OrdersShow = '/orders/[id]',
  OrdersInvoice = '/orders/[id]/invoice',
  Subscriptions = '/subscriptions',
  SubscriptionsChangelog = '/subscriptions/[id]/changelog',
  Surveys = '/surveys',
  TutorAttendanceRates = '/tutor-attendance-rates',

  Users = '/users',
  UserEdit = '/users/[id]',
  Teams = '/users/teams',
  TeamEdit = '/users/teams/[id]',

  Settings = '/settings',
  SettingsExperiments = '/settings/experiments',

  Helpers = '/helpers',
  HelpersSales = '/helpers/sales',
  HelpersTutors = '/helpers/tutors',
  HelpersBookings = '/helpers/bookings',
  HelpersNewsletters = '/helpers/newsletters',
  HelpersSystem = '/helpers/system',

  OAuth = '/oauth',

  ImportSalesTax = '/tools/import-sales-tax',

  ImportCurriculum = '/tools/import-curriculum',

  ImportTutorPayments = '/tools/import-tutor-payments',

  Assessments = '/content/assessments',
  AssessmentEdit = '/content/assessments/[id]',

  Changelog = '/changelog',
  Assignments = '/content/assignments',
  AssignmentEdit = '/content/assignments/[id]',
  Stories = '/content/stories',
  StoryEdit = '/content/stories/[id]',
}
